import {Config} from '@/config';
import {BaseApi} from './BaseApi';
import {of} from 'rxjs';
import {map} from 'rxjs/operators';
import {cacheObservableData} from './decorators';

export const LanguageCodes = {
  English: 'en',
  Russian: 'ru',
};

class TranslationsApi extends BaseApi {
  public buildApiUrl(path: string) {
    return `${Config.tournamentApiEndpoint}/hw_ajax.php?${path}`;
  }

  public getApiToken() {
    const w = window as any;
    return typeof w.getTranslationsApiAccessToken === 'function' ? w.getTournamentsApiAccessToken() : null;
  }

  public getDefaultTranslations() {
    return {
      approved: 'confirmed',
      unconfirmed: 'unconfirmed',
      discarded: 'discarded',
      approve: 'Approve',
      discard: 'Discard',
      reports_list: 'Reports table',
      reports_list_empty: 'No reports yet',
      players_list: 'Players table',
      players_list_empty: 'No players yet',
      requests_list: 'Requests table',
      requests_list_empty: 'No requests yet',
      confirm_request: 'Confirm',
      reject_request: 'Reject',
      tournament_requests_count: 'Tournament requests count:',
      players_count: 'Players count:',
      reports_count: 'Reports count:',
      name: 'Name',
      date: 'Date',
      organizer_comment: 'Organizer Comment',
      player_comment: 'Player Comment',
      icq: 'ICQ',
      skype: 'Skype',
      discord: 'Discord',
      enter_comment: 'Enter comment (max 128 symbols)',
      comment_required: 'The comment is required',
      comment_length_max: 'Max allowed length is 128 symbols',
      error: 'Error',
      http_error: 'There was an error occurred',
      confirmation: 'Confirmation',
      report: 'Report',
      color: 'Color',

      quick_access_shortcuts: 'Quick Access Shortcuts',
      quick_access_shortcut_lang: 'In Russian',
      quick_access_shortcut_rating: 'Rating Table',
      quick_access_shortcut_my_rating: 'My Rating',
      quick_access_shortcut_user_rating: '{username} Rating',
      quick_access_shortcut_unconfirmed_reports: 'Unconfirmed Reports',
      quick_access_shortcut_my_unconfirmed_reports: 'My Unconfirmed',
      quick_access_shortcut_user_unconfirmed_reports: '{username} Unconfirmed',

      rating_info: 'Rating details (active players only)',
      rating_info_all: 'Rating details (all players)',

      player_rating: 'Player\'s rating',

      link: 'Link',
      view_in_english: 'View the page in English',
      player: 'Player',
      victories: 'Victories',
      defeats: 'Defeats',
      draws: 'Draws',
      games: 'Games',
      rating: 'Rating',
      win_rate: 'WinRate',
      details: 'Details',
      active_players_info:
        'Rating table contains players having 20 or more games and whose rating changed ' +
        'at least once starting from',
      all_players_link_info: 'To see all players without time restriction',
      active_players_link_info: 'To see only active players whose rating changed at least ' +
        'once starting from',
      click_here: '(click here)',
      all_players_info: 'Rating table contains players having 20 or more games',
      rating_title: 'Players rating based on passed tournaments on HeroesWorld',
      last_rating_update_time: 'Last rating update time',
      unconfirmed_reports_info: 'Here is the link to the list of all unconfirmed reports',
      loading: 'Loading...',
      number: 'N',
      active_players_count: 'Active players count:',
      all_players_count: 'Players count:',
      data_filter_placeholder:
        'Table filter (it filters by equivalence of any field, query could be divided by space)',

      unconfirmed_reports: 'Unconfirmed reports',
      unconfirmed_reports_violators:
        'To see the list of unconfirmed reports violators ' +
        '(users who has more than 3 unconfirmed reports with a date greater than a month from now)',
      unconfirmed_reports_all_players: 'To see all players unconfirmed reports',
      unconfirmed_reports_no_violators: 'No violators found',
      played_tournaments: 'Played tournaments',
      reports_history: 'Games history',

      title: 'Title',
      start: 'Start',
      end: 'End',

      game_date: 'Game date',
      fraction: 'F',
      start_hero: 'Start',
      main_hero: 'Main',
      result: 'Res.',
      rival: 'Rival',

      template: 'Template',
      time: 'Time',
      confirm_link: 'Confirm',

      player_rating_change: 'Rating 1',
      rival_rating_change: 'Rating 2',

      links: 'Links',
      player_link: 'Player Link',
      rival_link: 'Rival Link',

      unknown_player: 'Unknown Player',
      unknown_player_desc: 'No information found about specified player',
    };
  }

  public getDefaultLang() {
    return LanguageCodes.English;
  }

  public isDefaultLang(lang: string) {
    return lang === this.getDefaultLang();
  }

  @cacheObservableData()
  public getTranslations(lang: string) {
    if (this.isDefaultLang(lang)) {
      return of(this.getDefaultTranslations());
    }
    return this.getJSON(`do=get_translations`)
      .pipe(map((x) => Object.assign(this.getDefaultTranslations(), x)));
  }
}

export const translationsApi = new TranslationsApi();
